<template>
    <div class="memorandum_action" v-if="!is_mem_load">
        <work_users_block></work_users_block>
        
        <!-- user Edit -->
        <adjust_editor></adjust_editor>
        <invoice_editor></invoice_editor>
        <adjust_replace></adjust_replace>
        <!-- addon_data -->
        
        
        <!-- main_action -->
        <legend>Обробка</legend>
        <b-tabs content-class="mt-3">
            <b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :disabled="tab.disabled" :title="get_tab_title(tab)" :key="index" :active="tab.is_active">
                <template slot="title">
                    {{get_tab_title(tab)}}
                    <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                </template>
                
                <component v-bind:is="index" :doc_id="mem_id" ></component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import Work_users_block from "./components/work_users_block.vue";
import Adjust_editor from "./user_editor/adjust_editor.vue";
import Invoice_editor from "./user_editor/invoice_editor.vue";
import adjust_replace from "./user_editor/adjust_replace.vue";

//Tabs
import tab_work from "./tabs/work/tab_work.vue";
import tab_resolution from "./tabs/resolution/tab_resolution.vue";
import tab_monitoring from "./tabs/monitoring/tab_monitoring.vue";
import tab_files from "./tabs/files/tab_files.vue";
import tab_linked from "./tabs/linked/tab_linked.vue";
import tab_message from "./tabs/message/tab_message.vue";

export default {
    name: "mem_action",
    components: {
        Invoice_editor,
        Adjust_editor,
        adjust_replace,
        Work_users_block,
        
        //Tabs
        tab_work,
        tab_resolution,
        tab_monitoring,
        tab_files,
        tab_linked,
        tab_message
    },
    
    computed: {
        ...mapGetters({
            'memorandum': "memorandum_inside/getMemorandum",
            'is_mem_load': "memorandum_inside/is_load",
            'tabs' : "memorandum_work_tabs/getTabs",
        }),
        
        mem_id () {
            if(this.memorandum.hasOwnProperty("id")) {
                return this.memorandum.id;
            }
            
            return 0;
        },
    },
    
    methods : {
        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title +' (' + tab.count + ')';
            }
            
            return tab.title;
        },
        
        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }
            
            this.tabs[obj].is_active = true;
            this.$store.dispatch('memorandum_work_tabs/SET_MEM_WORK_TABS',  this.tabs);
        }
        
    }
    
}
</script>



<style scoped>

</style>